import { BybSection, BybSectionList } from "@Components/common/byb-ds";
import BybPerformanceDiffLabel from "@Components/common/byb-ds/byb-performance-diff-label";
import ScrollfulContainer from "@Components/generic/scrollful-container";
import OverallProgressSection from "@Components/mobile/progress/overall-progress";
import RadialBarChartMobile from "@Components/mobile/progress/radial-chart";
import BybMetricsList from "@Components/mobile/shared/byb-metrics-list";
import { useProgress } from "@Context/game/progress/progress-context";
import { getPerformanceProgressLabel, getWeeklyProgressFeedbackTitle } from "@Helpers/feedback";
import useI18n from "@i18n";
import { Skeleton, Typography, useTheme } from "@mui/material";

const ProgressPerformance = () => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const {
    radarData,
    currentBybIq,
    currentStats,
    improvementPercentage,
    performanceScores,
    longTermResults,
    dateRange,
    setDateRange,
    optionsAnchorElement,
    setOptionsAnchorElement,
  } = useProgress();

  return (
    <ScrollfulContainer sx={{ paddingX: 0, paddingTop: theme.spacing(1) }}>
      <BybSectionList>
        <BybSection sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, paddingY: 5 }}>
          <RadialBarChartMobile data={radarData} />
          <Typography variant="text1xl600">{i18n("progress.performance.your-performance")}</Typography>
          {currentStats ? (
            <Typography variant="textS500" color={theme.palette.text.secondary} textAlign={"center"} width={"80%"}>
              {i18n(getWeeklyProgressFeedbackTitle(Number(currentStats.id), getPerformanceProgressLabel(improvementPercentage)))}
            </Typography>
          ) : (
            <>
              <Skeleton variant="rounded" width={"75%"} height={10}></Skeleton>
              <Skeleton variant="rounded" width={"70%"} height={10}></Skeleton>
            </>
          )}
          <BybPerformanceDiffLabel diff={improvementPercentage || 0} />
        </BybSection>
        <OverallProgressSection
          byb_iq={currentBybIq}
          longTermResults={longTermResults}
          dateRange={dateRange}
          optionsAnchorElement={optionsAnchorElement}
          setOptionsAnchorElement={setOptionsAnchorElement}
          setDateRange={setDateRange}
        />
        <BybMetricsList metricScores={performanceScores || {}} compact />
      </BybSectionList>
    </ScrollfulContainer>
  );
};

export default ProgressPerformance;
